import { navigateTo, useRoute } from '#imports'
import { toValue, watch } from 'vue'

import type { LinkInternal } from '@backmarket/http-api'
import { isEqual } from '@backmarket/utils/object/isEqual'

// Note: the input is () => xx instead of MaybeRefOrGetter because Vue only allows to watch a MaybeRef<T> input if T is an object. With 'LinkInternal | null', the type does not extends 'object'
export function useRedirectToCanonicalLink({
  canonicalLink,
}: {
  canonicalLink: () => LinkInternal | undefined
}) {
  watch(
    canonicalLink,
    () => {
      const link = toValue(canonicalLink)
      if (!link) return

      const route = useRoute()

      const isCanonicalUrl = isEqual(link.params, route.params)
      if (!isCanonicalUrl) {
        const newRoute = {
          ...route,
          params: link.params,
        }
        void navigateTo(newRoute)
      }
    },
    { immediate: true },
  )
}
